import { addClasses, hide } from 'lambda-dom'

import { ModalElement } from './speak-up.types'

export class SpeakUpModal {

    private readonly ref: string

    constructor(private element: ModalElement) {
        this.ref = this.element.dataset.speakupModal
    }

    show(): void {
        addClasses('active', 'show')(this.element)
    }

    hide(): void {
        hide(this.element)
    }

    reference(): string {
        return this.ref
    }

    isActive(): boolean {
        return this.element.style.display !== 'none'
    }
}
